<template>
  <div id="app" data-scroll-container ref="scrollSections">
    <div class="popbgs" :class="{'hide': loader}"></div>
    <headerBox :menuStatus="menuStatus" :scroll="scroll"/>
    <keep-alive>
      <div class="container">
        <router-view ref="container" :bannerStatus="bannerStatus" :scroll="scroll">
        </router-view>
      </div>
    </keep-alive>
    
    <div class="guest-pops" ref="popfix" :class="{'show': popShow}">
      <div class="guest-bg"  @click="popClose"></div>
      <div class="guest-wr-hide">
        <div class="guest-wrs">
          <img class="guest-close" @click="popClose" src="@/assets/images/close.svg" alt=""/>
          <div class="guest-hide">
            <figure><img :src="guestInfo.face" alt=""/></figure>
            <div class="guest-detail">
              <div class="guest-tops">
                <strong v-html="guestInfo.user"></strong>
                <!-- <p>{{guestInfo.title}}</p> -->
                <p v-html="guestInfo.title"></p>
              </div>
              <div class="guest-infos" v-html="guestInfo.detail">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footerbox data-scroll-section/>
  </div>
</template>
<script>
import locomotiveScroll from 'locomotive-scroll'
import headerBox from '@/components/common/HeaderBox'
import footerbox from '@/components/common/FooterBox'
export default {
  data () {
    return {
      screenWidth: document.body.clientWidth,
      scrollContainer: null,
      scroll: null,
      menuStatus: false,
      bannerStatus: false,
      hascrollbg: false,
      popShow: false,
      loader: false,
      guestInfo: [],
      scrollY: 0
    }
  },
  components: {
    headerBox,
    footerbox
  },
  methods: {
    initLocoScroll () {
      this.scrollContainer = document.querySelector('[data-scroll-container]')
      this.scroll = new locomotiveScroll({
        el: this.scrollContainer,
        smooth: true,
        smoothMobile: false,
        getDirection: true,
        initClass: true,
        lerp: 0.075,
        offset: [200, -200],
      })
     
      this.scroll.on('scroll', (args) => {
        this.scrollY = Math.round(args.scroll.y)
        if (this.scrollY >= 20) {
          this.menuStatus = true
          this.bannerStatus = false
        } else {
          this.menuStatus = false
          this.bannerStatus = true
        }
      })
      this.scroll.on('call', function (e, i, n) {
        // eslint-disable-next-line eqeqeq
        if (e === 'animateMove') {
          if (i === 'enter') {
            n.el.classList.add('animateMove')
          }
        }
      })
      setTimeout(() => {
        this.bannerStatus = true
      }, 500)

      setTimeout(()=> {
        this.scroll.update()
      }, 400)
    },
    setPopShow (item) {
      this.popShow = true
      this.guestInfo = item
      this.scroll.stop()
    },
    popClose () {
      this.popShow = false
      setTimeout(() => {
        this.guestInfo = ''
      }, 600)
      this.scroll.start()
    }
  },
  mounted () {
    const _self = this
    this.$nextTick(function () {
      _self.initLocoScroll()
      setTimeout(() => {
        _self.scroll.update()
      }, 400)
    })
    this.popShow = false
    this.loader = true
    const that = this
    window.onresize = () => (() => {
      window.screenWidth = document.body.clientWidth
      that.screenWidth = window.screenWidth
    })()

    this.$router.beforeEach((to, from, next) => {
      this.loader = false
      next()
    })

    this.$router.afterEach((to, from, next) => {
      setTimeout(() => {
        this.loader = true
      }, 350)
    })
  },
  // updated () {
  //   this.scroll.update()
  // },
  computed: {
    active_menu () {
      return this.$route.path
    }
  },
  watch: {
    screenWidth (val) {
      if (!this.timer) {
        // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
        this.screenWidth = val
        this.timer = true
        const that = this
        
         setTimeout(() => {
          that.scroll.update()
          that.timer = false
        }, 400)
      }
    },

    $route (to, from) {
      const that = this
      setTimeout(function () {
        that.scroll.scrollTo(0, { duration: 0 })
        that.scroll.update()
        that.menuStatus = false
        that.scrollY = 0
      }, 100)

      
    }
  }
}
</script>
<style lang="less" scoped>
  @import url("@/assets/css/common/guestView.less");
  .fade{
    &-enter-active, &-leave-active {
      transition: all 0.3s
    }
    &-enter, &-leave-active {
      opacity: 0
    }
  }
  .container{
    overflow: hidden;
  }
</style>
